import { useContext, useEffect } from 'react';
import { Button } from '@givebutter/primitives/button';
import { maskWholeNumber } from '@givebutter/util';
import { TableContext } from 'components/table/TableContext';

const TableHeaderSelectAllRow = () => {
    const { table } = useContext(TableContext);
    const tableState = table.getState();
    const rowCount = table.getRowCount();
    const selectedRowCount = table.getSelectedRowModel().flatRows.length;
    const isAllPageSelected = table.getIsAllPageRowsSelected();
    const setIsAllRecordsSelected = table.setIsAllRecordsSelected;
    const isAllRecordsSelected = table.getState().isAllRecordsSelected;
    const totalVisibleColumns = Object.values(tableState.columnVisibility).filter(Boolean).length;

    useEffect(() => {
        if (!isAllPageSelected && setIsAllRecordsSelected) {
            setIsAllRecordsSelected(false);
        }
    }, [isAllPageSelected, setIsAllRecordsSelected]);

    if (!isAllPageSelected || selectedRowCount >= rowCount || !setIsAllRecordsSelected) {
        return null;
    }

    return (
        <tr className="bg-blue-50">
            <td colSpan={totalVisibleColumns} className="px-6 py-2">
                <div className="flex items-center gap-2">
                    {isAllRecordsSelected
                        ? `All ${maskWholeNumber(rowCount)} rows are selected.`
                        : `${maskWholeNumber(selectedRowCount)} rows on this page are selected.`}
                    <Button
                        variant="none"
                        className="font-medium text-blue-600"
                        onClick={() => {
                            table.updateIsAllRecordsSelected(!isAllRecordsSelected);
                        }}
                    >
                        {isAllRecordsSelected
                            ? 'Undo'
                            : `Select all ${maskWholeNumber(rowCount)} rows`}
                    </Button>
                </div>
            </td>
        </tr>
    );
};

export { TableHeaderSelectAllRow };
